import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { useSlugScope } from "@/lib/scoped";

export default function LegalPageShell({ title, subtitle, lastUpdated, children, testId }) {
  const { user } = useAuth();
  const slug = useSlugScope();
  // Unauthenticated visitors go back to the bare-slug branded login when
  // we're inside a client env, otherwise the platform-wide login.
  const backTo = slug ? `/${slug}` : "/login";

  return (
    <div className="min-h-screen bg-white">
      {user ? (
        <Header />
      ) : (
        <header className="border-b border-zinc-200">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
            <Logo />
            <Link
              to={backTo}
              data-testid="legal-back-link"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-zinc-500 hover:text-zinc-950"
            >
              <ArrowLeft className="h-4 w-4" /> Back to login
            </Link>
          </div>
        </header>
      )}
      <main
        data-testid={testId}
        className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16"
      >
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">{subtitle}</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-zinc-950 mt-1">
          {title}
        </h1>
        <p className="mt-3 text-sm text-zinc-500">Last updated · {lastUpdated}</p>

        <div
          data-testid="legal-content"
          className="mt-10 text-zinc-700 leading-relaxed text-[15px] space-y-5
                     [&_h2]:font-heading [&_h2]:text-xl [&_h2]:font-bold [&_h2]:tracking-tight [&_h2]:text-zinc-950 [&_h2]:mt-10 [&_h2]:mb-2
                     [&_p]:my-3
                     [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:my-3 [&_ul]:space-y-1.5
                     [&_li]:marker:text-zinc-400
                     [&_a]:text-[#0038FF] [&_a]:underline [&_a]:underline-offset-2 [&_a:hover]:text-[#002BE6]
                     [&_code]:bg-zinc-100 [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:rounded-sm [&_code]:text-[13px] [&_code]:text-zinc-900"
        >
          {children}
        </div>
      </main>
    </div>
  );
}
